import { MISTYPED_EMAIL_DOMAINS } from './mistyped-email-domains';
export const isEmailDomainMistyped = (email)=>{
    const domain = email.trim().toLowerCase().split('@').pop() ?? '';
    return domain.length > 0 && MISTYPED_EMAIL_DOMAINS.has(domain);
};

//# sourceMappingURL=is-email-domain-mistyped.js.map